import {
    DropdownLabelRenderer,
    DropdownLabelRenderInfo,
} from 'components/dropdown/Dropdown';
import { ReactNode, useMemo, useRef } from 'react';
import * as React from 'react';
import { RequireDefined } from 'utils/types';

/**
 * The default amount of time to wait after the user types before
 * updating the results in the dropdown with fresh API results.
 */
export const defaultDebounceTime = 200;

export const onDropdownItemLinkClick = (event: React.MouseEvent) => {
    if (event.ctrlKey || event.metaKey) {
        event.stopPropagation();
    } else {
        event.preventDefault();
    }
};

export type SimpleDropdownLabelRenderer<TData> = (
    info: RequireDefined<DropdownLabelRenderInfo<TData>>
) => ReactNode;

export const useDropdownLabelRenderer = <T>({
    defaultRenderer,
    overrideRenderer,
    placeholder,
}: {
    defaultRenderer: SimpleDropdownLabelRenderer<T>;
    overrideRenderer?: SimpleDropdownLabelRenderer<T>;
    placeholder: string;
}): DropdownLabelRenderer<T> => {
    const defaultRendererRef = useRef(defaultRenderer);
    return useMemo(
        () =>
            overrideRenderer !== undefined
                ? // @ts-expect-error TS is not smart enough to realize we just checked for undefined
                  (info) => (info.value ? overrideRenderer(info) : placeholder)
                : // @ts-expect-error TS is not smart enough to realize we just checked for undefined
                  (info) => (info.value ? defaultRendererRef.current(info) : placeholder),
        [defaultRendererRef, overrideRenderer, placeholder]
    );
};
